<template>
  <div class="factories">
    <div class="search__box">
      <input v-model="filter" type='text' placeholder="Search Factories" />
    </div>
    <div class="factories__wrapper">
      <factory-line
        v-for="factory in filteredfactories"
        v-bind:key="factory.id"
        v-bind:factory="factory">
      </factory-line>
    </div>
  </div>
</template>

<script>
import {store} from '@/store'
import FactoryLine from '@/components/mainpage/FactoryLine'
export default {
  name: 'FactoryList',
  components: {
    FactoryLine
  },
  data: function(){
    return {
      filter: ''
    }
  },
  computed: {
    factories: function () {
      return store.state.factories
    },
    filteredfactories: function(){
      return this.factories.filter(f => f.business_name.toLowerCase().includes(this.filter.toLowerCase()))
    }
  }
}
</script>

<style scoped lang="less">
  .shadow {
    box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.25);
  }
  .factories {
    display: block;
    position: fixed;
    top: 60px;
    bottom: 0px;
    left: 0px;
    background: white;
    width: 250px;
    overflow-y: auto;
    z-index: 3000;
    &:extend(.shadow);
  }

  .search__box {
    display: block;
    box-sizing: border-box;
    border-bottom: solid 1px lightgray;
    position: sticky;
    top: 0px;
    z-index: 2000;
  }

  .search__box input {
    display: block;
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    border: none;
    font-size: 1em;
    background-color: #f4f4f4;
  }

</style>



// WEBPACK FOOTER //
// src/components/mainpage/FactoryList.vue